import React, { useEffect, useRef, useState } from "react";
import { Button } from "@progress/kendo-react-buttons";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import FormTextField from "../../components/formFields/FormTextField";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { LoadingPanel } from "../../components/layout/Loading";
import { closed } from "../../components/muidrawer/muiDrawerSlice";
import { Typography } from "@progress/kendo-react-common";
import { RxCross1 } from "react-icons/rx";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { STATUSARRAY } from "../../_contstants/common";
import FormTextArea from "../../components/formFields/FormTextArea";
import { clearBranchDetails } from "./branchSlice";
import {
  createBranch,
  getAllBranch,
  getBranchByID,
  updateBranch,
} from "./services/branch.services";
import { getAllActiveServices } from "../services/services/services.services";

const CreateBranch: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  const BranchDetail = useAppSelector((state) => state.branches.BranchDetail);
  const BranchID = useAppSelector((state) => state.muidrawer.data);
  const [formKey, setFormKey] = useState(1);

  const serviceList = useAppSelector((state) => state.services.ServiceList);

  useEffect(() => {
    setFormKey(formKey + 1);
  }, [BranchDetail]);

  const loading = useAppSelector((state) => state.weprovide.formloading);

  useEffect(() => {
    dispatch(getAllActiveServices());
    return () => {
      dispatch(clearBranchDetails());
      dispatch(closed());
    };
  }, []);

  useEffect(() => {
    if (BranchID) {
      dispatch(getBranchByID(BranchID));
    }
  }, [BranchID]);

  const handleSubmit = async (values: any) => {
    try {
      if (!BranchID) {
        const insertPayload = {
          Country: values.Country ? values.Country : "",
          Address: values.Address ? values.Address : "",
          Phone: values.Phone ? values.Phone : "",
          Email: values.Email ? values.Email : "",
          IsActive: values.IsActive === 1,
        };
        const response = await dispatch(createBranch(insertPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());
          dispatch(clearBranchDetails());
          dispatch(getAllBranch());
        }
      } else {
        const editPayload = {
          ID: values.ID,
          Country: values.Country ? values.Country : "",
          Address: values.Address ? values.Address : "",
          Phone: values.Phone ? values.Phone : "",
          Email: values.Email ? values.Email : "",
          IsActive: values.IsActive === 1,
        };
        const response = await dispatch(updateBranch(editPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());
          dispatch(clearBranchDetails());
          dispatch(getAllBranch());
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  const handleFormClose = () => {
    dispatch(closed());
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <Form
        onSubmit={handleSubmit}
        initialValues={BranchDetail}
        key={formKey}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement style={{ width: "100%" }}>
            <GridLayout
              style={{
                display: "flex",
                flexWrap: "wrap",
              }}
              gap={{ rows: 10 }}
              cols={[{ width: "100%" }]}
            >
              <GridLayoutItem
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginTop: 20,
                }}
              >
                <Typography.h4 className="m-0">
                  {BranchID ? "Update Branch" : "Add Branch"}
                </Typography.h4>
                <Button
                  type="button"
                  fillMode={"flat"}
                  themeColor={"dark"}
                  style={{ marginRight: 4 }}
                  onClick={() => dispatch(closed())}
                >
                  <RxCross1 />
                </Button>
              </GridLayoutItem>
              <GridLayoutItem style={{ width: "100%" }}>
                <Field
                  id={"Country"}
                  name={"Country"}
                  label={"Country"}
                  placeholder={"Title"}
                  component={FormTextField}
                  validator={requiredValidator}
                  astrike={true}
                />
              </GridLayoutItem>
              <GridLayoutItem style={{ width: "100%" }}>
                <Field
                  wrapperClassName="right-aligned-field"
                  name="Address"
                  label="Address"
                  placeholder="Address"
                  component={FormTextArea}
                  validator={requiredValidator}
                  astrike={true}
                />
              </GridLayoutItem>
              <GridLayoutItem style={{ width: "100%" }}>
                <Field
                  id={"Phone"}
                  name={"Phone"}
                  label={"Phone No."}
                  component={FormTextField}
                  validator={requiredValidator}
                  astrike={true}
                  options={serviceList?.map((service: any) => {
                    return {
                      value: service.ID,
                      label: service.Title,
                    };
                  })}
                />
              </GridLayoutItem>
              <GridLayoutItem style={{ width: "100%" }}>
                <Field
                  id={"Email"}
                  name={"Email"}
                  label={"Email ID"}
                  component={FormTextField}
                  validator={requiredValidator}
                  astrike={true}
                  options={serviceList?.map((service: any) => {
                    return {
                      value: service.ID,
                      label: service.Title,
                    };
                  })}
                />
              </GridLayoutItem>
              <GridLayoutItem style={{ width: "100%" }}>
                <Field
                  id={"IsActive"}
                  name={"IsActive"}
                  label={"Status"}
                  component={FormSelectionField}
                  validator={requiredValidator}
                  astrike={true}
                  options={STATUSARRAY?.map((status: any) => {
                    return {
                      value: status.value,
                      label: status.label,
                    };
                  })}
                />
              </GridLayoutItem>
              <GridLayoutItem
                colSpan={3}
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <ButtonWithLoading
                  label={BranchID ? "Update" : "Create"}
                  type="submit"
                  disabled={!formRenderProps.allowSubmit || loading}
                  loading={loading}
                />

                <Button
                  type="button"
                  fillMode={"outline"}
                  themeColor={"primary"}
                  style={{ marginLeft: 10 }}
                  onClick={handleFormClose}
                >
                  Cancel
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </FormElement>
        )}
      />
    </>
  );
};

export default CreateBranch;
